import { IResponseObjectSuccess } from '@core/interfaces';
import { Client, OrderForm, OrderResponse } from '@core/models';

export interface CheckoutConfirmationEmailData {
	idAccount: string | undefined;
	email: string | undefined;
}

export function getCheckoutConfirmationEmailData(
	order: IResponseObjectSuccess<OrderResponse>,
	orderForm: OrderForm
): CheckoutConfirmationEmailData {
	const account = order?.data?.payloadJuvo?.cuentas?.[0];
	const idAccount = account?.idCuenta ?? account?.accountId;
	const email =
		orderForm.userData?.email ??
		orderForm.auth?.user?.correo ??
		(orderForm.auth as Client)?.correo;

	return { idAccount, email };
}
